import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { selectTemplatesActiveTab } from '../../store/templatesSlice';
import { Button } from '../../../../shared/ui/button/Button';
import { TextTemplateCreateButton } from './components/TextTemplateCreateButton';
import { CREATE_TEMPLATE_BUTTON_VARIANTS } from './lib/constants';
import { resolveCreateButtonVariant } from './lib/createTemplateButtonHelpers';

export function CreateTemplateButton({ size = 'sm', onClick, className = '' }) {
  const activeTab = useSelector(selectTemplatesActiveTab);
  const variant = resolveCreateButtonVariant(activeTab);

  if (variant === CREATE_TEMPLATE_BUTTON_VARIANTS.TEXT_DROPDOWN) {
    return <TextTemplateCreateButton size={size} onClick={onClick} className={className} />;
  }

  return (
    <Button className={clsx(className)} onClick={onClick} size={size} variant="primary">
      Create Template
    </Button>
  );
}
